module.exports = {"632322100":"马克堂镇","632322101":"康扬镇","632322102":"坎布拉镇","632322200":"贾加乡","632322201":"措周乡","632322202":"昂拉乡","632322203":"能科乡","632322204":"当顺乡","632322205":"尖扎滩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632322.json
// module id = 2997
// module chunks = 0